/* eslint-disable max-len */
var OV_CONCIERGE_API_KEY = process.env.OV_CONCIERGE_API_KEY;
export { OV_CONCIERGE_API_KEY };
var OV_CONCIERGE_MODE = process.env.OV_CONCIERGE_MODE;
export { OV_CONCIERGE_MODE };
var OV_CONCIERGE_OPT_IN_URL = process.env.OV_CONCIERGE_OPT_IN_URL;
export { OV_CONCIERGE_OPT_IN_URL };
var DEFAULT_ORG_NAME = '{{WARNING: add your org name via config.orgName}}'; //PHONE INPUT

var PHONE_COUNTRIES = ['us'];
var PHONE_NUMBER_LENGTH = 10;
var PHONE_DEFAULT_PLACEHOLDER = 'Enter Phone Number';
var SMS_OPT_IN_DEFAULT_CONFIG = {
  orgName: DEFAULT_ORG_NAME,
  header: "Don't miss your chance",
  subheader: 'Get updated via SMS about new products, events and more!',
  phonePlaceholder: 'Phone number',
  buttonText: 'Subscribe',
  successText: 'Thank you. We have sent you a message to confirm your subscription.',
  formContainerStyle: {
    textAlign: 'center',
    fontFamily: 'Helvetica'
  },
  buttonStyle: {
    padding: '10px',
    width: '60%'
  },
  buttonDisabledStyle: {
    opacity: 0.7,
    padding: '10px',
    width: '60%',
    cursor: 'not-allowed'
  },
  headerStyle: {
    fontSize: '2rem'
  },
  subheaderStyle: {
    fontSize: '1.2rem'
  },
  phoneInputStyle: {
    padding: '10px',
    width: '60%'
  },
  smsLegalNoticeStyle: {
    fontSize: '0.8rem'
  },
  smsLegalNotice: "By providing your phone number, you agree to receive recurring automated marketing text messages from {{org_name}}. Frequency varies by account. Consent is not a condition of purchase. Carrier message and data rates may apply.",
  onSuccess: function onSuccess() {},
  onError: function onError(error) {
    console.error(error);
  }
};
export { PHONE_COUNTRIES, PHONE_NUMBER_LENGTH, SMS_OPT_IN_DEFAULT_CONFIG, PHONE_DEFAULT_PLACEHOLDER };